<template>
  <div class="container-fluid  align-items-center" v-loading="loading">
    <div class="row mb-3" v-if="isMultiSessionEvent">
      <div class="col-12">
        <label class="form-control-label">Day / Session</label>
        <el-select v-model="selectedSessionId" placeholder="Select Session" style="width: 100%">
          <el-option
            v-for="session in eventSessions"
            :key="session.id"
            :label="getSessionLabel(session)"
            :value="session.id">
          </el-option>
        </el-select>
      </div>
    </div>

    <el-tabs v-model="activeTab" type="card" @tab-click="handleTabChange" v-if="isCorporateEvent">
      <el-tab-pane label="Basic" name="basic">
        <Basic :leadEvent="leadEventDetails || leadEvent" :event_type="event_type" :sessionId="selectedSessionId" @eventTypeChange="eventTypeChange" @onSave="onBasicSave" @onSessionCreated="onSessionCreated"/>
      </el-tab-pane>
      <el-tab-pane label="Event Format" name="format" :disabled="areTabsDisabled">
        <EventFormat :leadEvent="leadEventDetails || leadEvent" :sessionId="selectedSessionId" @onSave="onEventFormatSave"/>
      </el-tab-pane>
      <el-tab-pane label="Services" name="services" :disabled="areTabsDisabled">
        <Services :leadEvent="leadEventDetails || leadEvent" :sessionId="selectedSessionId" @onSave="onServicesSave"/>
      </el-tab-pane>
      <el-tab-pane label="Additional Info" name="additional-info" :disabled="areTabsDisabled">
        <AdditionalInfo :leadEvent="leadEventDetails || leadEvent" :sessionId="selectedSessionId" @onSave="onAdditionalInfoSave"/>
      </el-tab-pane>
    </el-tabs>
    <div v-else>
      <SimpleBasic :leadEvent="leadEventDetails || leadEvent" @eventTypeChange="eventTypeChange" :event_type="event_type" @onSave="onBasicSave"/>
    </div>
  </div>
</template>
<script>
import {
  Select,
  Option,
  Alert,
  Tabs,
  TabPane
} from "element-ui";
import datePicker from "vue-bootstrap-datetimepicker";
import Basic from '@/views/Widgets/LeadDetails/Components/Edit/Basic';
import SimpleBasic from '@/views/Widgets/LeadDetails/Components/Edit/SimpleBasic';
import EventFormat from '@/views/Widgets/LeadDetails/Components/Edit/EventFormat';
import Services from '@/views/Widgets/LeadDetails/Components/Edit/Services';
import AdditionalInfo from '@/views/Widgets/LeadDetails/Components/Edit/AdditionalInfo';
import leadEventService from "@/services/lead-event.service";

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [Alert.name]: Alert,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    datePicker,
    Basic,
    SimpleBasic,
    EventFormat,
    Services,
    AdditionalInfo,
  },
  props: {
    leadEvent:  {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      activeTab: 'basic',
      event_type: this.leadEvent.event_type,
      leadEventDetails: null,
      selectedSessionId: null,
    };
  },
  computed: {
    isCorporateEvent() {
      return this.event_type === 'corporate';
    },
    eventSessions() {
      return (this.leadEventDetails && (this.leadEventDetails.eventSessions || this.leadEventDetails.event_sessions)) || this.leadEvent.eventSessions || [];
    },
    isMultiSessionEvent() {
      return this.eventSessions && this.eventSessions.length > 1;
    },
    areTabsDisabled() {
      return !this.selectedSessionId;
    }
  },
  created() {
    this.getLeadEventDetails();
  },
  methods: {
    getSessionLabel(session) {
      return `Day ${session.day_number} | Session ${session.session_number} - "${session.name}"`;
    },
    handleTabChange(tab) {
      console.log(tab)
    },
    eventTypeChange(value) {
      this.event_type = value;
    },
    async getLeadEventDetails() {
      this.loading = true;
      let leadEventData = await leadEventService.getLeadEventData(this.leadEvent.id);
      this.loading = false;
      leadEventData = leadEventData.data;

      // Process event sessions to add day_number and session_number
      if (leadEventData.event_sessions && leadEventData.event_sessions.length > 0) {
        // Sort sessions by start_time
        leadEventData.event_sessions.sort((a, b) => new Date(a.start_time) - new Date(b.start_time));

        let currentDay = 0;
        let currentSession = 0;
        let lastDate = null;

        leadEventData.event_sessions.forEach(session => {
          const sessionDate = session.start_time.split(' ')[0]; // Assuming 'YYYY-MM-DD HH:mm:ss' format
          
          if (sessionDate !== lastDate) {
            currentDay++;
            currentSession = 1;
            lastDate = sessionDate;
          } else {
            currentSession++;
          }

          session.day_number = currentDay;
          session.session_number = currentSession;
        });
      }

      this.leadEventDetails = leadEventData;
      
      if (this.leadEvent.event_type == 'corporate' && !this.selectedSessionId && this.eventSessions.length > 0) {
        this.selectedSessionId = this.eventSessions[0].id;
      }
    },
    async onBasicSave(result) {
      // Refresh the lead event details to get the updated data
      await this.getLeadEventDetails();
      if (this.isCorporateEvent && this.activeTab === 'basic') {
        this.activeTab = 'format';
      }
    },
    onSessionCreated(sessionId) {
      this.selectedSessionId = sessionId;
      this.getLeadEventDetails();
    },
    onEventFormatSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'format') {
        this.activeTab = 'services';
      }
    },
    onServicesSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'services') {
        this.activeTab = 'additional-info';
      }
    },
    onAdditionalInfoSave(result) {
      // Refresh the lead event details to get the updated data
      this.getLeadEventDetails();
      if (this.activeTab === 'additional-info') {
        this.activeTab = 'basic';
      }
    }
  },
};
</script>